import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "We moved our fintech HQ from London to DIFC in under 6 weeks. StartINC handled the licensing, golden visa and HSBC account in parallel — the kind of discipline I expected from a top-tier law firm.",
    name: "Priya Raghavan",
    title: "Co-founder & CEO, Kairos Capital",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=256&q=80",
    rating: 5,
  },
  {
    quote:
      "Our Mashreq application had been sitting for 4 months with another agency. StartINC re-structured the file, introduced us to the right RM, and we had an AED/USD account inside 3 weeks.",
    name: "Ahmed Al Mansoori",
    title: "Managing Director, Meridian Logistics",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=256&q=80",
    rating: 5,
  },
  {
    quote:
      "As a solo consultant I thought UAE setup would be overwhelming. The StartINC team gave me a clear 5-week roadmap, a freezone I'd never considered, and saved me ~40% on year-one costs.",
    name: "Elena Sokolova",
    title: "Founder, Northwind Advisory",
    image:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=256&q=80",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-white py-20 md:py-32"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <p className="overline text-[#3366FF]">Founders on the record</p>
            <div className="gold-rule mt-5 mb-6" />
            <h2 className="font-heading font-light tracking-tight text-[#0F172A] text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Trusted by operators across{" "}
              <span className="font-black text-[#002366]">40+ countries</span>.
            </h2>
          </div>
          <div className="flex items-center gap-3 text-slate-600">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 fill-[#3366FF] text-[#3366FF]"
                />
              ))}
            </div>
            <span className="text-sm">
              <span className="font-heading font-bold text-[#0F172A]">4.9/5</span> · 300+
              reviews on Google & Trustpilot
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative rounded-sm border border-slate-200 bg-white p-8 hover:shadow-xl hover:border-[#3366FF]/40 transition-all"
            >
              <Quote className="w-7 h-7 text-[#3366FF]" strokeWidth={1.5} />
              <blockquote className="mt-5 text-slate-700 leading-relaxed text-[15px]">
                "{t.quote}"
              </blockquote>
              <div className="mt-8 pt-6 border-t border-slate-200 flex items-center gap-4">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover ring-2 ring-[#EEF2FF]"
                  loading="lazy"
                />
                <figcaption>
                  <div className="font-heading font-semibold text-[#0F172A]">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500">{t.title}</div>
                </figcaption>
                <div className="ml-auto flex gap-0.5">
                  {[...Array(t.rating)].map((_, s) => (
                    <Star key={s} className="w-3.5 h-3.5 fill-[#3366FF] text-[#3366FF]" />
                  ))}
                </div>
              </div>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
